export class EContract {
  constructor(
    public customerFirstName: string,
    public customerLastName: string,
    public customerMiddleName: string,
    public formNumber: string,
    public customerAddress1: string,
    public customerAddress2: string,
    public customerCity: string,
    public customerState: string,
    public customerZipcode: string,
    public customerHomePhone: string,
    public customerWorkPhone: string,
    public customerEmail: string,
    public customerCountryCode: string,
    public cosignerFirstName: string | null,
    public cosignerLastName: string | null,
    public cosignerMiddleName: string | null,
    public cosignerAddress1: string | null,
    public cosignerAddress2: string | null,
    public cosignerCity: string | null,
    public cosignerState: string | null,
    public cosignerZipcode: string | null,
    public cosignerHomePhone: string | null,
    public cosignerWorkPhone: string | null,
    public cosignerEmail: string | null,
    public cosignerCountryCode: string | null,
    public lienholderName: string | null,
    public lienholderAddress1: string | null,
    public lienholderAddress2: string | null,
    public lienholderCity: string | null,
    public lienholderState: string | null,
    public lienholderZipCode: string | null,
    public lienholderCountryCode: string | null,
    public lienholderEmail: string | null,
    public lienholderFax: string | null,
    public lienholderPhone: string | null,
    public dealerCompanyName: string,
    public dealerNumber: string,
    public dealerAddress: string,
    public dealerCity: string,
    public dealerState: string,
    public dealerZipCode: string,
    public dealerPhone: string,
    public dealerFax: string,
    public productCode: string,
    public productSKU: string,
    public coverageCode: string,
    public term: number | null | undefined,
    public customerCost: number | null | undefined,
    public saleDate: string,
    public deductible: number,
    public startingInterval: number,
    public termMileage: number,
    public vin: string,
    public year: string,
    public make: string,
    public model: string,
    public trim: string,
    public odometer: number,
    public msrp: number|string,
    public inServiceDate: string,
    public vehicleCondition: string,
    public vehiclePurchasePrice: number,
    public contractDealerCost: number,
    public currencyCode: string,
    public monthlyBillingType: string
  ) {
  }
}
